module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"reset":"初始化","confirm":"完成"}}')
  delete Component.options._Ctor
}
